export const SPREADSHEET_ID = "1o7CxYz1UI1xTYAgOh9XZ0XM4UtVfsUIjwll1KJVKDtE";
export const SHEET_ID = "Sheet1";
export const API_KEY = "AIzaSyCJ-OwS_CHE1aIcz4osT4bPa1Q6Mc2AolE"; 